import { App } from 'components/TodoList/App';
import React from 'react';

function TodoList() {
  return <App />;
}

export default TodoList;
